import React, { memo } from 'react';
import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import {
  GridComponent,
  TooltipComponent,
  VisualMapComponent
} from 'echarts/components';
import { HeatmapChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import dayjs from 'dayjs';
import { Card } from 'react-bootstrap';

echarts.use([
  GridComponent,
  TooltipComponent,
  VisualMapComponent,
  HeatmapChart,
  CanvasRenderer
]);

const AlarmDensityHeatmap = ({ alarms = [] }) => {
  if (!alarms.length) return null;

  // ==========================================================
  // 1️⃣ Construim o hartă: day → array[24] cu număr alarme/ora
  // ==========================================================
  const dayMap = {};

  alarms.forEach(r => {
    const day = r.oppositeContent?.date; // ex: "04 Dec, 2025"
    const time = r.oppositeContent?.time; // ex: "11:25 PM"

    if (!day || !time) return;

    const full = dayjs(`${day} ${time}`, 'DD MMM, YYYY hh:mm A');
    if (!full.isValid()) return;

    const dayKey = full.format('YYYY-MM-DD');
    const hour = full.hour();

    if (!dayMap[dayKey]) {
      dayMap[dayKey] = Array(24).fill(0);
    }

    dayMap[dayKey][hour] += 1;
  });

  const days = Object.keys(dayMap).sort();
  if (!days.length) return null;

  const heatmapData = [];

  days.forEach((day, dayIndex) => {
    dayMap[day].forEach((count, hour) => {
      heatmapData.push([hour, dayIndex, count]);
    });
  });

  const maxCount = Math.max(...heatmapData.map(x => x[2])) || 1;

  const option = {
    tooltip: {
      formatter: params => {
        const hour = params.value[0].toString().padStart(2, '0') + ':00';
        const date = days[params.value[1]];

        return `
<b>${dayjs(date).format('DD MMM, YYYY')}</b><br/>
Hour: <b>${hour}</b><br/>
Alarms: <b>${params.value[2]}</b>
`;
      }
    },

    grid: {
      top: 60,
      bottom: 40,
      left: 90,
      right: 20
    },

    xAxis: {
      type: 'category',
      data: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')),
      axisLabel: { rotate: 45 }
    },

    yAxis: {
      type: 'category',
      data: days.map(d => dayjs(d).format('DD MMM')),
      axisLabel: { fontSize: 12 }
    },

    visualMap: {
      min: 0,
      max: maxCount,
      calculable: true,
      orient: 'horizontal',
      left: 'center',
      bottom: 0,
      inRange: {
        color: ['#d4f4dd', '#7ad17a', '#f2c94c', '#eb5757']
      }
    },

    series: [
      {
        type: 'heatmap',
        data: heatmapData,
        itemStyle: {
          borderWidth: 1,
          borderColor: '#ffffff'
        }
      }
    ]
  };

  return (
    <Card className="h-100 w-100">
      <Card.Body style={{ padding: 0 }}>
        <ReactEChartsCore
          echarts={echarts}
          option={{
            ...option,
            grid: {
              top: 50,
              bottom: 40,
              left: 60, // ajustat pentru a nu tăia labelurile
              right: 20
            }
          }}
          style={{ width: '100%', height: 300 }}
        />
      </Card.Body>
    </Card>
  );
};

export default memo(AlarmDensityHeatmap);
